import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { createStudent } from '../../lib/api'
import { keys } from '../../lib/queryKeys'
import { PageHeader } from '../../components/PageHeader'
import { StudentForm, type StudentFormValues } from '../../components/StudentForm'
import { m } from '../../paraglide/messages'

export const Route = createFileRoute('/students/new')({
  component: NewStudentPage,
})

function NewStudentPage() {
  const navigate    = useNavigate()
  const queryClient = useQueryClient()
  const [error, setError] = useState('')

  const mutation = useMutation({
    mutationFn: createStudent,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: keys.students })
      navigate({ to: '/students/$id', params: { id: String(data.id) } })
    },
    onError: (err) => setError((err as Error).message),
  })

  const handleSubmit = (v: StudentFormValues) => {
    setError('')
    mutation.mutate({
      name:  v.name,
      phone: v.phone || undefined,
      email: v.email || undefined,
      rate:  v.rate,
      notes: v.notes || undefined,
    })
  }

  return (
    <div>
      <PageHeader title={m.students_new()} />
      <StudentForm
        submitLabel={m.students_add()}
        pendingLabel={m.students_adding()}
        pending={mutation.isPending}
        error={error}
        onSubmit={handleSubmit}
        footer={
          <Link to="/students" className="border border-zinc-900 px-3 py-1.5 text-sm hover:bg-zinc-100">
            {m.action_cancel()}
          </Link>
        }
      />
    </div>
  )
}
